import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import axios from "axios";
import "./sihirLanding.css";

const APP_STORE_URL = "https://apps.apple.com/app/id6478240257";
const API_BASE = "https://us-central1-testtme-tarot-soru-cevap.cloudfunctions.net/api";

const EMAILJS = {
  publicKey: "63B7oQgvqOLsUqJZJ",
  serviceId: "service_w6ir3fh",
  templateId: "template_izvoswb",
};

const SHOTS = [
  {
    src: "/screenshots/final-01-bugun.png",
    alt: "Bugün — ruh hali, konu ve düşünce",
    caption: "Bugün",
  },
  {
    src: "/screenshots/final-02-defterim.png",
    alt: "Defterim — kayıt timeline",
    caption: "Defterim",
  },
  {
    src: "/screenshots/final-03-kayit.png",
    alt: "Kayıt detayı — bakış açısı",
    caption: "Kayıt",
  },
  {
    src: "/screenshots/final-04-icgorulerim.png",
    alt: "İçgörülerim — özet ve temalar",
    caption: "İçgörülerim",
  },
  {
    src: "/screenshots/final-05-giris.png",
    alt: "Sihir Defteri giriş ekranı",
    caption: "Giriş",
  },
];

async function sendContact({ name, email, message }) {
  try {
    await axios.post(`${API_BASE}/sendMessage`, { name, email, message }, { timeout: 15000 });
    return { via: "api" };
  } catch (apiErr) {
    try {
      emailjs.init(EMAILJS.publicKey);
      await emailjs.send(EMAILJS.serviceId, EMAILJS.templateId, {
        name,
        email,
        message: `${message}\n\n— ${email}`,
      });
      return { via: "emailjs" };
    } catch (ejErr) {
      const apiMsg = apiErr?.response?.data?.message || apiErr?.message || "api_failed";
      const ejMsg = ejErr?.text || ejErr?.message || "emailjs_failed";
      throw new Error(`${apiMsg} / ${ejMsg}`);
    }
  }
}

function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState({ type: "", text: "" });
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) {
      setStatus({ type: "err", text: "Lütfen tüm alanları doldur." });
      return;
    }
    setBusy(true);
    setStatus({ type: "pending", text: "Mesajın iletiliyor…" });
    try {
      await sendContact({
        name: name.trim(),
        email: email.trim(),
        message: message.trim(),
      });
      setStatus({
        type: "ok",
        text: "Mesajın ulaştı. En kısa sürede dönüş yapacağız.",
      });
      setName("");
      setEmail("");
      setMessage("");
    } catch {
      setStatus({
        type: "err",
        text: "Gönderilemedi. Lütfen testtmeapp@gmail.com adresine yaz veya biraz sonra dene.",
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="sd-form" onSubmit={onSubmit} noValidate>
      <div className="sd-field">
        <label htmlFor="sd-name">İsim</label>
        <input
          id="sd-name"
          name="name"
          autoComplete="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Adın"
        />
      </div>
      <div className="sd-field">
        <label htmlFor="sd-email">E-posta</label>
        <input
          id="sd-email"
          name="email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="ornek@mail.com"
        />
      </div>
      <div className="sd-field">
        <label htmlFor="sd-message">Mesaj</label>
        <textarea
          id="sd-message"
          name="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Destek, öneri veya bir not yaz…"
        />
      </div>
      <button className="sd-btn sd-btn--gold" type="submit" disabled={busy}>
        {busy ? "Gönderiliyor…" : "Mesajı gönder"}
      </button>
      <p
        className={`sd-form__status sd-form__status--${status.type || "pending"}`}
        role="status"
        aria-live="polite"
      >
        {status.text}
      </p>
    </form>
  );
}

export default function SihirDefteriLanding() {
  return (
    <div className="sd-landing">
      <div className="sd-atmosphere" aria-hidden="true" />
      <div className="sd-shell">
        <header className="sd-nav">
          <a className="sd-nav__brand" href="#top">
            Sihir Defteri
          </a>
          <nav className="sd-nav__links" aria-label="Ana">
            <a className="sd-hide-sm" href="#nasil">
              Nasıl
            </a>
            <a className="sd-hide-sm" href="#ekranlar">
              Uygulama
            </a>
            <a className="sd-hide-sm" href="#iletisim">
              İletişim
            </a>
            <a className="sd-nav__cta" href={APP_STORE_URL} target="_blank" rel="noreferrer">
              App Store
            </a>
          </nav>
        </header>

        <main id="top">
          <section className="sd-hero" aria-label="Tanıtım">
            <div className="sd-hero__copy">
              <p className="sd-overline">Kişisel yansıma defteri</p>
              <h1>Sihir Defteri</h1>
              <p className="sd-hero__lead">
                Senin hikâyen, ruh halin ve zaman içindeki izlerin. Kaydetmek için reklam, AI veya
                rehber gerekmez.
              </p>
              <div className="sd-hero__actions">
                <a
                  className="sd-btn sd-btn--gold"
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  App Store’da aç
                </a>
                <a className="sd-btn sd-btn--ghost" href="#ekranlar">
                  Ekranlara bak
                </a>
              </div>
            </div>
            <div className="sd-hero__visual">
              <div className="sd-phone">
                <img
                  src="/screenshots/final-01-bugun.png"
                  alt="Sihir Defteri — Bugün ekranı"
                  width={280}
                  height={608}
                />
              </div>
            </div>
          </section>

          <section className="sd-section" id="nasil">
            <div className="sd-section__head">
              <p className="sd-overline">Nasıl işler</p>
              <h2>Yaz. Kaydet. İzlerini gör.</h2>
              <p>
                Acele yok. Bugünün ruh halini seç, düşünceni yaz — defterin zaman içinde sana ayna
                tutar.
              </p>
            </div>
            <div className="sd-ritual">
              <article className="sd-ritual__item">
                <div className="sd-ritual__num">01</div>
                <h3>Bugün yaz</h3>
                <p>
                  Ruh halini ve konunu seç, aklından geçenleri kaydet. Defterime Kaydet — ek bir
                  adım yok.
                </p>
              </article>
              <article className="sd-ritual__item">
                <div className="sd-ritual__num">02</div>
                <h3>Defterinde biriktir</h3>
                <p>
                  Tüm kayıtların tek timeline’da. Geçmiş yazılarına istediğin zaman dön; hikâyen
                  sende kalır.
                </p>
              </article>
              <article className="sd-ritual__item">
                <div className="sd-ritual__num">03</div>
                <h3>İçgörüleri fark et</h3>
                <p>
                  Ruh hali ve tema özetleriyle tekrar eden desenleri gör. İstersen farklı bir bakış
                  açısı al.
                </p>
              </article>
            </div>
          </section>

          <section className="sd-section" id="ekranlar">
            <div className="sd-section__head">
              <p className="sd-overline">Uygulama</p>
              <h2>Karanlık, altın ve nefes alan bir arayüz.</h2>
              <p>
                Sihir Defteri; sakin ve kişisel. Gürültü yok — yalnızca sen, yazdıkların ve zaman
                içindeki izlerin.
              </p>
            </div>
            <div className="sd-shots">
              {SHOTS.map((s) => (
                <figure className="sd-shot" key={s.src}>
                  <img src={s.src} alt={s.alt} loading="lazy" />
                  <figcaption>{s.caption}</figcaption>
                </figure>
              ))}
            </div>
          </section>

          <section className="sd-promise" aria-label="Konumlandırma">
            <blockquote>
              “Sihir Defteri; senin hikâyen, ruh halin ve zaman içindeki izlerin.”
            </blockquote>
            <cite>Sihir Defteri</cite>
          </section>

          <section className="sd-section" id="iletisim">
            <div className="sd-contact">
              <div className="sd-section__head" style={{ marginBottom: 0 }}>
                <p className="sd-overline">İletişim</p>
                <h2>Bir şey mi kaldı içerde?</h2>
                <p>
                  Destek, öneri veya gizlilik talepleri için yaz. Mesajın bize ulaşır — spam değil,
                  insan.{" "}
                  <a href="/privacy" style={{ color: "var(--gold-soft)" }}>
                    Gizlilik politikası
                  </a>
                </p>
                <p style={{ marginTop: "1.25rem" }}>
                  <a href="mailto:testtmeapp@gmail.com" style={{ color: "var(--gold-soft)" }}>
                    testtmeapp@gmail.com
                  </a>
                </p>
              </div>
              <ContactForm />
            </div>
          </section>
        </main>

        <footer className="sd-footer">
          <div>
            <div className="sd-footer__brand">Sihir Defteri</div>
            <div>© {new Date().getFullYear()} · Kişisel yansıma defteri</div>
          </div>
          <nav aria-label="Alt">
            <a href="/privacy">Gizlilik</a>
            <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
              App Store
            </a>
            <a href="mailto:testtmeapp@gmail.com">Destek</a>
          </nav>
        </footer>
      </div>
    </div>
  );
}
